import React, {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import {Accordion, AccordionTab} from "primereact/accordion";

const CompOpinionCard = ({assessmentItem, onSupervisorOpinionChange, optionList}) => {
    const [indicator, setIndicator] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const onOpinionChange = e => {
        const competencyOpinionID = e.currentTarget.value
        onSupervisorOpinionChange(competencyOpinionID, assessmentItem)
    }

    useEffect(() => {
        //console.log("test")
        const json = {
            competencyID: assessmentItem.comId,
            registerID: assessmentItem.selectedEmployeeId
        }
        getCompIndicator(json)
    }, [])

    const getCompIndicator = (body) => {
        setIsLoading(true)
        axios.post(BASE_URL + "/api/utility/SelectedCompetencyIndicator", body)
            .then(response => {
                setIsLoading(false)
                if (response.status === 200) {
                    setIndicator(response.data)
                }
            }).catch(e => {
            setIsLoading(false)
            console.log(e)
        })
    }

    return (<div className="card">
        <div className="card-header">
            <h6> {assessmentItem.assestmentName}</h6>
        </div>
        <div className="card-body">
            <Accordion activeIndex={1}>
                <AccordionTab header="Indicators">
                    {isLoading ? <ProgressSpinner style={{width: '50px', height: '50px'}}/> : <ul>
                        {indicator.map((value, index) => (<div key={index}>
                            <li style={{listStyle: 'none'}}><b>{value.indicatorSequenceNo}. </b> {value.indicatorTitle}</li>
                        </div>))}
                    </ul>}
                </AccordionTab>
            </Accordion>

            <p className="pOpinion d-none"><b>Employee Opinion:</b> {assessmentItem.opinionName}</p>            
            <select className="form-select"
                    onChange={onOpinionChange}
                    // defaultValue={assessmentItem.supervisorCompetencyOpinionID === null ? assessmentItem.userCompetencyOpinionID : assessmentItem.supervisorCompetencyOpinionID }
                    defaultValue={assessmentItem.supervisorCompetencyOpinionID}
                    aria-label=".form-select-sm example">
                <option value={-1}>Select Opinion</option>
                {optionList.map((value, index) => <option key={index}
                    value={value.competencyOpinionID}>{value.title}/{value.titleBangla}({value.weight})
                </option>)}
            </select>
        </div>
    </div>)
}

export default CompOpinionCard